module.exports = __webpack_public_path__ + "static/media/B2.71939485.webp";